<p>
  Ако попаднете на съмнително поведение, некоректен потребител или потенциална измама в платформата, може да подадете
  сигнал към нашия екип. Това е важен механизъм за поддържане на безопасна и етична среда за всички потребители.
</p>
<h6 class="mt-3">Как да подадете сигнал?</h6>
<p class="mb-1">
  Имате две възможности за подаване на сигнал:
</p>
<ol>
  <li>
    Чрез
    <a class="text-decoration-none"
       [routerLink]="[appRoutes.root, appRoutes.contactUs]">
      формата за контакт
    </a> на сайта.
  </li>
  <li>
    От <strong>профила на потребителя</strong>, когото искате да докладвате – натиснете бутона
    <strong>„Още“</strong> и изберете <strong>„Докладвай потребител“</strong>.
  </li>
</ol>
<h6 class="mt-3">Каква информация да включите?</h6>
<p class="mb-1">
  Когато подавате сигнал, опишете подробно ситуацията, причината за притеснението ви и приложете, ако е възможно:
</p>
<ul>
  <li>Линк към съответната обява или потребител;</li>
  <li>Допълнителни детайли, които биха помогнали на екипа ни да разбере по-добре случая.</li>
</ul>
<h6 class="mt-3">Какво се случва след подаден сигнал?</h6>
<p>
  Всеки сигнал се разглежда индивидуално от модераторския екип в кратък срок. Ако се установи нарушение на правилата,
  могат да бъдат предприети действия като предупреждение, временно ограничаване или трайно блокиране на достъпа до
  платформата.
</p>
<div class="alert alert-primary m-0">
  <strong>Важно:</strong> Всички сигнали се обработват <strong>анонимно</strong>. Вашата самоличност няма да бъде
  разкрита на другата страна при никакви обстоятелства.
</div>
